// extracted by mini-css-extract-plugin
export default {"wrapper":"FiltersTabContent_wrapper__LLmwy","chunk":"FiltersTabContent_chunk__tiZsq","filterTabOptions":"FiltersTabContent_filterTabOptions__Gm+uo"};